import type { StandardState, GemMeterState } from '../types/types';
import CHECK_LIST, { SHOPABLE_PREFIX } from '../constants/rulesConstants';

export function initStoreData() {
  const initShopableStandards: StandardState = {};
  const initConvertableStandards: StandardState = {};
  Object.keys(CHECK_LIST).forEach((key) => {
    const item = CHECK_LIST[key as keyof typeof CHECK_LIST];
    if (item.id.includes(SHOPABLE_PREFIX)) {
      initShopableStandards[item.id] = {
        id: item.id,
        key,
        screen: {
          lg: {
            errorElements: {},
            status: null,
            elementLength: 0,
          },
          md: {
            errorElements: {},
            status: null,
            elementLength: 0,
          },
          sm: {
            errorElements: {},
            status: null,
            elementLength: 0,
          },
          xs: {
            errorElements: {},
            status: null,
            elementLength: 0,
          },
        },
        isPageValidate: item.isPageRule,
      };
    } else {
      initConvertableStandards[item.id] = {
        id: item.id,
        key,
        screen: {
          lg: {
            errorElements: {},
            status: null,
            elementLength: 0,
          },
          md: {
            errorElements: {},
            status: null,
            elementLength: 0,
          },
          sm: {
            errorElements: {},
            status: null,
            elementLength: 0,
          },
          xs: {
            errorElements: {},
            status: null,
            elementLength: 0,
          },
        },
        isPageValidate: item.isPageRule,
      };
    }
  });

  return [initShopableStandards, initConvertableStandards];
}

const [initShopableStandards, initConvertableStandards] = initStoreData();

const gemMeterState: GemMeterState = {
  version: 1.92,
  recheckLoading: false,
  isHighLightAll: false,
  shopableStandards: initShopableStandards,
  convertableStandards: initConvertableStandards,
  elementGroups: {
    lg: {},
    md: {},
    sm: {},
    xs: {},
  },
  metric: {
    lg: {
      fixed: 0,
      skipped: 0,
      errors: 0,
    },
    md: {
      fixed: 0,
      skipped: 0,
      errors: 0,
    },
    sm: {
      fixed: 0,
      skipped: 0,
      errors: 0,
    },
    xs: {
      fixed: 0,
      skipped: 0,
      errors: 0,
    },
  },
  initializeStatus: {
    lg: false,
    md: false,
    sm: false,
    xs: false,
  },
  elementsOfRules: {},
  isInitialize: false,
  pageElements: {},
  groupItem: null,
  openModal: false,
  loading: false,
  groupLoading: false,
  previousScreen: 'lg',
  inconsistentData: {
    fontFamily: null,
    fontWeight: null,
    isPreview: false,
  },
  openLibraryFromGemMeter: false,
  pageRules: [],
  images: [],
};

export default gemMeterState;
